import * as C from 'constants/Redux'

const PREFIX = 'SIP / '
const CONFIG = 'CREATE_CONFIG'
const CREATE_AGENT = 'CREATE_USER_AGENT'
const REGISTER_AGENT = 'REGISTER_USER_AGENT'
const SESSION = '_SESSION_OPTIONS'
const CREDENTIALS = 'CREDENTIALS'

export const CREATE_CONFIG_SESSION_OPTIONS = PREFIX + CONFIG + SESSION
export const CREATE_CONFIG = PREFIX + CONFIG
export const CREATE_CONFIG_PENDING = CREATE_CONFIG + C.PENDING
export const CREATE_CONFIG_FULFILLED = CREATE_CONFIG + C.FULFILLED
export const CREATE_CONFIG_REJECTED = CREATE_CONFIG + C.REJECTED

export const CREATE_USER_AGENT = PREFIX + CREATE_AGENT
export const CREATE_USER_AGENT_PENDING = CREATE_USER_AGENT + C.PENDING
export const CREATE_USER_AGENT_FULFILLED = CREATE_USER_AGENT + C.FULFILLED
export const CREATE_USER_AGENT_REJECTED = CREATE_USER_AGENT + C.REJECTED

export const REGISTER_USER_AGENT = PREFIX + REGISTER_AGENT
export const REGISTER_USER_AGENT_PENDING = REGISTER_USER_AGENT + C.PENDING
export const REGISTER_USER_AGENT_FULFILLED = REGISTER_USER_AGENT + C.FULFILLED
export const REGISTER_USER_AGENT_REJECTED = REGISTER_USER_AGENT + C.REJECTED

export const FETCH_CREDENTIALS = PREFIX + CREDENTIALS + C.FETCH
export const FETCH_CREDENTIALS_PENDING = FETCH_CREDENTIALS + C.PENDING
export const FETCH_CREDENTIALS_FULFILLED = FETCH_CREDENTIALS + C.FULFILLED
export const FETCH_CREDENTIALS_REJECTED = FETCH_CREDENTIALS + C.REJECTED

export const INITIAL_STATE = {
  sessionOptions: {
    mediaConstraints: {
      audio: true,
      video: false,
    },
    pcConfig: {
      iceServers: [
        {
          urls: false,
        },
      ],
    },
  },
  config: {
    username: '',
    password: '',
    register: true,
    session_timers_refresh_method: 'invite',
    sockets: [],
    uri: '',
    user_agent: 'liveninja-unite',
    no_answer_timeout: 600,
  },
  error: false,
  loading: false,
  userAgent: false,
}
